// constants.js — empty BASE_URL = same origin (Vite proxies /api → :5002)
export const BASE_URL = '';

export const PRODUCTS_URL = '/api/products';
export const USERS_URL = '/api/users';
export const ORDERS_URL = '/api/orders';
export const ORDERSOFFICE_URL = '/api/ordersOffice';
export const PAYPAL_URL = '/api/config/paypal';
export const UPLOAD_URL = '/api/upload';
